type AnyObject = Record<string, any>;

function isPlainObject(v: any): v is AnyObject {
  if (v === null || typeof v !== 'object') return false;
  const proto = Object.getPrototypeOf(v);
  return proto === Object.prototype || proto === null;
}

export function merge<T extends AnyObject>(target: T, ...sources: AnyObject[]): T {
  if (!sources.length) return target;

  const source = sources.shift();
  if (typeof source !== 'object' || source === null) return merge(target, ...sources);

  const tgt = target as AnyObject;

  for (const key of Object.keys(source)) {
    const srcVal = source[key];
    const tgtVal = tgt[key];

    if (isPlainObject(srcVal)) {
      if (!isPlainObject(tgtVal)) {
        tgt[key] = {};
      }
      merge(tgt[key], srcVal);
    } else {
      tgt[key] = srcVal;
    }
  }

  return merge(target, ...sources);
}
